import React from "react";
import styled from "styled-components";
import { ReactComponent as ArrowLeftSvg } from "../src/assets/svg/arrow-left-white.svg";
import { ReactComponent as EditIcon } from "../src/assets/svg/EditIcon.svg";
import { useNavigate } from "react-router-dom";
import { IconButton, Typography } from "@mui/material";
import { useResponsive } from "./hooks/useResponsive";
import MenuIcon from "@mui/icons-material/Menu";
import { useDispatch, useSelector } from "react-redux";
import { toggleMobileOpenVariable } from "./redux/menuBar/action";

import CustomDialog from "./components/CustomDialog";
import EditVehicle from "./pages/vehicles/editVehicle/updateVehicle";
import EditDriver from "./pages/drivers/editDriver";
import EditProfile from "./pages/editProfile";

const MobileNav = styled.ul`
  display: none;
  flex-direction: column;
  margin: 0;
  padding: 0;

  @media (max-width: 767px) {
    display: flex;
  }
`;

const NavBar = ({
  title,
  redirectTo = "",
  redirectToData,
  isReDirect = true,
  myRef,
  enableBack = true,
  enableMenu = true,
  previousScreenTitle,
}) => {
  const [isMobileNavOpen] = React.useState(false);
  const [dialogProps, setDialogProps] = React.useState({
    isOpen: false,
    Content: null,
    reset: () =>
      setDialogProps((prev) => ({ ...prev, isOpen: false, Content: null })),
  });
  const navigate = useNavigate();
  const lgUp = useResponsive("up", "lg");
  const smDown = useResponsive("down", "sm");
  const { mobileOpen, isClosing } = useSelector(
    (state) => state.menuBarReducer,
  );
  const dispatch = useDispatch();

  const getDialogProps = (path) => {
    switch (path) {
      case "/editDriver":
        return {
          title: "Edit Driver",
          Content: EditDriver,
        };

      case "/editVehicle":
        return {
          title: "Edit Vehicle",
          Content: EditVehicle,
        };

      case "/editProfile":
        return {
          title: "Edit Profile",
          Content: EditProfile,
        };

      default:
        break;
    }
  };

  const handleEditClick = () => {
    if (smDown) {
      if (isReDirect) {
        navigate(redirectTo);
      } else {
        navigate(redirectTo, { state: redirectToData });
      }
      return;
    }
    const props = getDialogProps(redirectTo);
    setDialogProps((prev) => ({ ...prev, ...props, isOpen: true }));
  };

  const Nav = styled.nav`
    position: sticky;
    top: 0;
    z-index: 5;
    display: flex;
    justify-content: space-between;
    align-items: center;
    min-height: 56px;
    padding-left: 16px;
    padding-right: 16px;
    background: ${!lgUp ? "#1D5AB9" : "#1D5AB9"};
    boxshadow: ${!lgUp
      ? "none"
      : "0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)"};
  `;

  const handleDrawerToggle = () => {
    if (!isClosing) {
      dispatch(toggleMobileOpenVariable(!mobileOpen));
    }
  };

  return (
    <Nav
      sx={{
        flexGrow: 1,
      }}
    >
      {!lgUp && enableMenu && (
        <IconButton
          size="large"
          edge="start"
          color={!lgUp ? "white" : "#1D5AB9"}
          aria-label="menu"
          sx={{ mr: 2 }}
          onClick={handleDrawerToggle}
        >
          <MenuIcon style={{ color: !lgUp ? "white" : "#1D5AB9" }} />
        </IconButton>
      )}
      {enableBack && (
        <div
          style={{
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            display: "flex",
          }}
        >
          <ArrowLeftSvg
            style={{ cursor: "pointer" }}
            sx={{ alignSelf: "center" }}
            onClick={() => {
              navigate(-1);
            }}
          />
          <Typography
            sx={{
              fontFamily: "Segoe UI",
              fontSize: 18,
              fontWeight: 600,
              textAlign: "left",
              color: "#FFFFFF",
            }}
          >
            {previousScreenTitle}
          </Typography>
        </div>
      )}
      <Typography
        style={{
          fontFamily: "Segoe UI",
          fontSize: 20,
          fontWeight: 600,
          textAlign: "left",
          margin: "auto",
          color: lgUp ? "white" : "white",
          textIndent: !lgUp ? "-10%" : "-15%",
        }}
      >
        {title}
      </Typography>
      {redirectTo && (
        <EditIcon
          className="edit_icon"
          onClick={handleEditClick}
          style={{ cursor: "pointer" }}
        />
      )}
      <MobileNav
        style={{
          display: isMobileNavOpen ? "flex" : "none",
          backgroundColor: "#1D5AB9",
        }}
      ></MobileNav>
      {dialogProps.isOpen && <CustomDialog {...dialogProps} />}
    </Nav>
  );
};

export default NavBar;
